import { v4 as uuid } from 'uuid'

export class TypeformLogicJumpCondition {
    constructor(
        readonly id: string,
        public op: string,
        public vars: Array<{ type: string, value: string }>|TypeformLogicJumpCondition[],
    ) {}

    toRequestData(): any {
        return {
            op: this.op,
            vars: this.vars,
        }
    }

    static fromData(data: any): TypeformLogicJumpCondition {
        if (data === null || typeof data === 'string' || data instanceof TypeformLogicJumpCondition) {
            return data
        }

        return new TypeformLogicJumpCondition(
            data.id || uuid(),
            data.op,
            data.vars,
        )
    }
}
